<p-button
    (onClick)="onClick()"
    [pTooltip]="l('::Export')"
    icon="pi pi-file-excel"
    [label]="l('::Export')"
    tooltipPosition="left"
    fluid
    [outlined]="true">
</p-button>